import React from 'react';
import i18next from 'i18next';
import BtnGroup from '../BtnGroup/BtnGroup';
import ButtonIcon from '../Button/ButtonIcon';

import chatIcon from 'icons/chat.svg';
import refIcon from 'icons/ref.svg';
import personIcon from 'icons/person.svg';
import { connect } from 'react-redux';

class SideNav extends React.Component {
  changeTab = (tab) => {
    this.props.onChange(tab);
  };

  render() {
    return (
      <div className="side-nav">
        <BtnGroup>
          <ButtonIcon
            glyph={chatIcon}
            onClick={this.changeTab.bind(this, 'chat')}
            active={this.props.activeTab === 'chat' ? 'active' : null}
          >
            {i18next.t('blocks.chat')}
          </ButtonIcon>
          <ButtonIcon
            glyph={refIcon}
            onClick={this.changeTab.bind(this, 'refs')}
            active={this.props.activeTab === 'refs' ? 'active' : null}
            disabled={!this.props.signedIn ? 'disabled' : null}
          >
            {i18next.t('blocks.refs')}
          </ButtonIcon>
          <ButtonIcon
            glyph={personIcon}
            onClick={this.changeTab.bind(this, 'cabinet')}
            active={this.props.activeTab === 'cabinet' ? 'active' : null}
            disabled={!this.props.signedIn ? 'disabled' : null}
          >
            {i18next.t('blocks.cabinet')}
          </ButtonIcon>
        </BtnGroup>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    signedIn: !!state.user.profile,
  };
}, {})(SideNav);



// WEBPACK FOOTER //
// ./app/components/SideNav/SideNav.jsx